import "core-js/modules/es6.number.constructor";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/wamp64/www/contractor-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/wamp64/www/contractor-site/node_modules/@babel/runtime/helpers/esm/objectSpread.js";
import { mapActions, mapGetters } from "vuex";
import NewQuantityBox from "../Elements/NewQuantityBox.vue";
import { EventBus } from "../store/eventBus";
export default {
  components: {
    NewQuantityBox: NewQuantityBox
  },
  data: function data() {
    return {
      items: {
        qty: 0
      },
      favorites: "",
      fav_frm: {
        id: "",
        favorites: []
      },
      create_fav: "",
      cart_items: [],
      total: 0,
      cart_id: null
    };
  },
  computed: _objectSpread({}, mapGetters(["errors"]), mapGetters("cart", ["projectCart"]), mapGetters("Common", ["ShowRoom"]), mapGetters({
    showroomId: 'Common/MyItem'
  })),
  methods: _objectSpread({}, mapActions("cart", ["getCartData", "removeCartRequest", "updateCartRequest"]), {
    fev_popup: function () {
      var _fev_popup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.fav_frm.id = item.product_sizes_id; //item.id;
              if (item.favorite) {
                this.fav_frm.action = "remove";
                this.add_to_favorites();
              } else {
                delete this.fav_frm.action;
                $("#pop_fav").modal("show");
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fev_popup(_x) {
        return _fev_popup.apply(this, arguments);
      }
      return fev_popup;
    }(),
    update_cart: function () {
      var _update_cart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var cartloader, payload;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cartloader = this.$loading.show(); // console.log("this.cart_items",this.cart_items);
              // if(this.cart_items) {
              //     localStorage.setItem("cart_item", JSON.stringify(this.cart_items));
              //     cartloader.hide();
              // }else{
              payload = {
                items: this.projectCart.Project_tans
              };
              if (localStorage.getItem('cart_id')) {
                payload.temp_project_id = localStorage.getItem('cart_id');
              }
              this.updateCartRequest(payload).then(function (res) {
                cartloader.hide();
              }).catch(function (err) {
                cartloader.hide();
              });
              // }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function update_cart() {
        return _update_cart.apply(this, arguments);
      }
      return update_cart;
    }(),
    calculate_cart_total: function calculate_cart_total() {
      var cart_price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var coupon_percent = 0;
      var discount_price = 0;
      if (this.applied_coupon && this.applied_coupon.discount && !isNaN(this.applied_coupon.discount)) {
        coupon_percent = Number(this.applied_coupon.discount);
      }
      discount_price = Number(cart_price * coupon_percent / 100);
      this.discount_amt = discount_price.toFixed(2);
      return Number(cart_price - discount_price).toFixed(2);
    },
    remove_cart: function () {
      var _remove_cart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, project_id, index) {
        var _this = this;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log(index);
              Swal.fire({
                title: "Are You Sure You Want To Remove This Item?",
                text: "Item Will Be Removed From Your Cart.",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, Remove It!"
              }).then(function (result) {
                if (result.value) {
                  if (index != null) {
                    // this.cart_items.splice(index, 1);
                    // localStorage.setItem("cart_item", JSON.stringify(this.cart_items));
                    // EventBus.$emit('cart-updated');
                    // console.log("removed index: " + index);
                  } else {
                    var data = {
                      id: id,
                      params: {
                        project: project_id,
                        temp_project_id: _this.cart_id
                      }
                    };
                    _this.removeCartRequest(data).then(function (res) {});
                    EventBus.$emit('cart-updated');
                  }
                }
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function remove_cart(_x2, _x3, _x4) {
        return _remove_cart.apply(this, arguments);
      }
      return remove_cart;
    }(),
    add_to_favorites: function () {
      var _add_to_favorites = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              console.log("here fevvvvvvvvvvvv");
              axios.post("api/visualization/add_to_favorite", this.fav_frm).then(function (res) {
                console.log("res: ", res);
                // let arr = this.products.data;
                // let pid = this.fav_frm.id;
                // var index = arr.indexOf(
                //     arr.filter(function (item) {
                //         return item.id == pid;
                //     })[0]
                // );
                //   this.products.data[index].favorite=res.data.data
                _this2.fav_frm.id = "";
                _this2.fav_frm.action = "";
                _this2.fav_frm.favorites = [];
                $("#pop_fav").modal("hide");
                window.location.reload();
              }).catch(function (err) {});
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function add_to_favorites() {
        return _add_to_favorites.apply(this, arguments);
      }
      return add_to_favorites;
    }(),
    create_favorite: function () {
      var _create_favorite = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;
        var loader;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.create_fav) {
                loader = this.$loading.show();
                axios.post("api/favorite", {
                  name: this.create_fav
                }).then(function (res) {
                  _this3.create_fav = "";
                  _this3.favorites.push(res.data.data);
                  Toast.fire({
                    icon: "success",
                    title: res.data.message
                  });
                  loader.hide();
                }).catch(function (err) {
                  loader.hide();
                });
              }
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function create_favorite() {
        return _create_favorite.apply(this, arguments);
      }
      return create_favorite;
    }()
  }),
  created: function created() {
    this.favorites = this.ShowRoom;
    this.cart_id = localStorage.getItem("cart_id");
    // let cart_itemsL=localStorage.getItem('cart_item');
    // // console.log("=====<>?", cart_itemsL);
    // if(cart_itemsL){
    //     cart_itemsL=JSON.parse(cart_itemsL);
    //     this.cart_items = cart_itemsL;
    //     console.log("=====<<<<",this.cart_items);

    //     this.cart_items.map(el=>{
    //         this.total+=el.final_price;
    //     })
    //     console.log(this.total);
    // }
    //
  }
};